import type { PropsWithChildren } from "react";
import * as styles from "./AlertV2.styles.ts";
import { CloseButton } from "src/components/CloseButton/CloseButton.tsx";
import { type HTMLMotionProps, motion } from "framer-motion";
import { StatusIcon } from "src/components/StatusIcon/StatusIcon.tsx";

export type AlertV2Severity = "info" | "success" | "error" | "warning";

export type AlertV2Props = PropsWithChildren<
  {
    severity?: AlertV2Severity;
    showCloseButton?: boolean;
    onClose?: () => void;
    progress?: number;
    pulsate?: boolean;
    pulsateIcon?: boolean;
  } & HTMLMotionProps<"div">
>;

export const AlertV2 = (props: AlertV2Props) => {
  const {
    severity = "info",
    children,
    showCloseButton = false,
    pulsate = false,
    pulsateIcon = false,
    progress,
    onClose,
    ...rest
  } = props;

  return (
    <motion.div css={styles.container({ severity, pulsate })} {...rest}>
      <div css={styles.statusIconContainer}>
        <StatusIcon pulsate={pulsateIcon} severity={severity} />
      </div>

      <div css={styles.content}>{children}</div>
      {showCloseButton && (
        <CloseButton onClick={onClose} css={styles.closeButton} />
      )}
      {progress && <div css={styles.progress({ severity, progress })} />}
    </motion.div>
  );
};
